import request from "@/utils/request";
// 获取@我的信息
export function getMyAiteInfoApi(data) {
  return request({
    method: "GET",
    url: "notify/at_list",
    params: data
  });
}

// 获取@我的信息
export function getMyCommentInfoApi(data) {
  return request({
    method: "GET",
    url: "notify/comments",
    params: data
  });
}

// 获取@我的信息
export function getMyLikeInfoApi(data) {
  return request({
    method: "GET",
    url: "notify/likes",
    params: data
  });
}
